import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, forkJoin, map, of } from 'rxjs';
import { ComparatorRepository } from 'src-adisco/repositories/comparator.repository';
import { CommonService } from 'src-adisco/services/common.service';
import { ProductService } from 'src-adisco/services/product.service';
import { getPriceLevelLabel } from 'src-adisco/utils/getPriceLevelLabel';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
interface CompanyName {
  companyName: string;
}
// interface UrlImage {
//   urlImage: string;
// }
@Component({
  selector: 'app-slide-product',
  templateUrl: 'slide-product.component.html',
  styleUrls: ['./slide-product.component.css'],
  providers: [MessageService],

})
export class SlideProductComponent {
  @Input() item: any;
  responsiveOptions!: any[];
  listId: any[] = [];
  listProduct: any[] = []
  listNameCompany: CompanyName[] = [];
  // listUrlImageProduct: UrlImage[] = [];
  constructor(
    private _productService: ProductService,
    private dynamicDocumentService: DynamicDocumentService,
    private _commonService: CommonService,
    public userService: UserService,
    private comparatorRepository: ComparatorRepository,
    private _messageService: MessageService,
  ) { }
  ngOnInit() {
    this.responsiveOptions = [
      {
        breakpoint: '1199px',
        numVisible: 2,
        numScroll: 2
      },
      {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 2
      },
      {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
    this.listId = [];
    if (this.item && this.item?.[0]) {
      this.item?.forEach((item: any) => {
        this.listId.push(item?.documentId);
      });
    }
    this.getListProduct(this.listId);
  }

  getListProduct(ids: any[]): void {
    this._productService.getListProductbyIds(ids).subscribe({
      next: (res) => {
        this.listProduct = res;
        const supplierRequests = this.listProduct.map(product =>
          this.getNameSupplier(product?.nameSupplier[0]?.value)
        );

        // const imageRequests = this.listProduct.map(product =>
        //   product?.supplierItemNumber
        //     ? this.getListImage(product?.supplierItemNumber)
        //     : of('src-adisco/assets/images/image-default.jpeg')
        // );

        // const tariffRequests = this.listProduct.map(product => {
        //   if (product?.linkToTariff && product?.linkToTariff[0]) {
        //     const listIdTariff: any[] = product.linkToTariff.map((item: any) => item?.documentId);
        //     return this.getTariff(listIdTariff);
        //   } else {
        //     return of('');
        //   }
        // });
        // forkJoin([...supplierRequests, ...imageRequests, ...tariffRequests]).subscribe(results => {
        //   const supplierResults = results.slice(0, supplierRequests.length);
        //   const imageResults = results.slice(supplierRequests.length, supplierRequests.length + imageRequests.length);
        //   const tariffResults = results.slice(supplierRequests.length + imageRequests.length);

        //   this.listProduct = this.listProduct.map((product, index) => ({
        //     ...product,
        //     companyName: supplierResults[index],
        //     urlImage: imageResults[index],
        //     price: tariffResults[index]?.price,
        //     priceLevelLabel: getPriceLevelLabel(tariffResults[index].priceLevel)
        //   }));
        // });
        forkJoin([...supplierRequests/* , ...imageRequests */]).subscribe(results => {
          const supplierResults = results.slice(0, supplierRequests.length);
         /*  const imageResults = results.slice(supplierRequests.length, supplierRequests.length + imageRequests.length); */
          //const tariffResults = results.slice(supplierRequests.length + imageRequests.length);

          this.listProduct = this.listProduct.map((product, index) => ({
            ...product,
            companyName: supplierResults[index],
            urlImage: /* imageResults[index] */[],
            //price: tariffResults[index]?.price,
           // priceLevelLabel: getPriceLevelLabel(tariffResults[index]?.priceLevel)
          }));

        });
      },
      error: (error) => {
      }
    });
  }
  getNameSupplier(code: any): Observable<any> {
    return this.dynamicDocumentService.find({
      collectionName: 'dynamic_legal_entity',
      filters: [
        {
          "fieldName": "code",
          "conditions": [
            {
              "type": "EQUALS",
              "value": code
            }
          ]
        }
      ],
      page: 1,
      pageSize: 150
    }).pipe(
      map((res: any) => {
        if (res.content[0]?.companyName != null) {
          return res.content[0].companyName;
        }
        return '';
      })
    );
  }
  getListImage(supplierItemNumber: any): Observable<string> {
    return this.dynamicDocumentService.find({
      collectionName: 'dynamic_ressource',
      filters: [
        {
          fieldName: 'linkToProduct',
          conditions: [
            {
              type: 'EQUALS',
              value: supplierItemNumber,
              minValue: '',
              maxValue: ''
            }
          ]
        }
      ],
      sorts: {},
      page: 1,
      pageSize: 25
    }).pipe(
      map((res: any) => {
        const dataListImage = res.content;
        const firstMatchingItem = dataListImage.find((item: any) => {
          return item.typeOfResource?.value === 'PHOTO' && item.file?.length > 0;
        });
        return firstMatchingItem?.file[0]?.url || 'src-adisco/assets/images/image-default.jpeg';
      })
    );
  }
  getTariff(ids: any[]): Observable<any> {
    return this._commonService.getDataTariff(ids).pipe(
      map((res) => {
        const data = res.response;
        const filteredData = data.filter((item: any) => item?.year && item?.year?.value === "N");
        if (filteredData.length > 0) {
          const latestItem = filteredData.reduce((prev: any, current: any) => {
            return (prev.price > current.price) ? prev : current;
          });
          return { price: latestItem?.price, priceLevel: latestItem?.priceLevel?.value };
        }
        return '';
      })
    );
  };


  addProductToCompare(id?: string): void {
    let listProductCompare = JSON.parse(localStorage.getItem('compare') as any);

    if (listProductCompare?.length > 4) {
      this._messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Maximum 5 produits',
        life: 3000,
      });
      return;
    }
    if (!id) return;
    this.comparatorRepository.addProduct([id]);
  }
}
